import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { useMediaQuery } from "@mui/material";
import Button from "components/Buttons/ThemeButton";
import { TopBarButton } from "components/PageTopNavV2/styled";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useWebStoreContext } from "contexts";
import { useNavigationMenu } from "hooks/useNavigationMenu";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import { CrownIcon } from "utils/svgIcons";
import {
	Arrow,
	Background2,
	Text,
	Tiki2
} from "../../../TutorialLoyaltyShop/styles";
import { ArrowContainer, Container, SlideNumberContainer } from "./style";

interface Slide6Props {
	onNext: () => void;
	onSkip: () => void;
}

export const Slide6 = ({ onNext, onSkip }: Slide6Props) => {
	const { getImage } = useImagePath("cdn");
	const background = getImage(tutorialAssets.background);
	const arrowUp = getImage(tutorialAssets.greenArrow);
	const tiki = getImage(tutorialAssets.char2);
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(
		isPortrait ? 400 : 500,
		isPortrait ? 200 : 400
	);
	const [mainMenuPosition, setMainMenuPosition] = useState<DOMRect | null>(
		null
	);
	const buttonRef = useRef<HTMLDivElement | null>(null);

	const { userTracker, nowTime } = useWebStoreContext();
	const navigation = useNavigationMenu(
		userTracker?.clubId,
		false,
		userTracker,
		nowTime
	).filter(
		(navItem) =>
			!navItem?.isExternal &&
			navItem?.isEnabled &&
			navItem?.isDisplayInPageTopNav
	);

	const handleResize = () => {
		const mainMenu = document.getElementById("page-top-nav-main-menu-crown");
		setMainMenuPosition(mainMenu?.getBoundingClientRect() as DOMRect);
	};

	const debounceResize = debounce(handleResize, 300);

	useEffect(() => {
		if (navigation) {
			handleResize();
		}
	}, [navigation?.length, buttonRef?.current]);

	useEffect(() => {
		window.addEventListener("resize", debounceResize);
		window.addEventListener("transitionend", debounceResize);

		return () => {
			window.removeEventListener("resize", debounceResize);
			window.removeEventListener("transitionend", debounceResize);
		};
	}, []);

	return (
		<>
			<TopBarButton
				ref={buttonRef}
				className="default-nav is-active"
				style={{
					position: "fixed",
					top: mainMenuPosition?.top,
					left: mainMenuPosition?.left,
					height: "29px",
					width: "155px",
					transition: "none"
				}}
			>
				<CrownIcon />
				<span>
					{navigation.find((navItem) => navItem.icon === "crown")?.title}
				</span>
			</TopBarButton>
			<Container
				scale={scale}
				top={
					((mainMenuPosition?.top || 0) +
						(mainMenuPosition?.height || 0) +
						10) *
					scale
				}
				left={
					(mainMenuPosition?.left || 0) +
					(mainMenuPosition?.width || 0) / 2 -
					120 * scale
				}
			>
				<ArrowContainer>
					<Arrow src={arrowUp} alt="Arrow up" width={46} />
				</ArrowContainer>
				<SlideNumberContainer>
					<Text
						color="#fff"
						fontFamily="Baloo"
						fontSize="16px"
						lineHeight="17px"
					>
						8/8
					</Text>
				</SlideNumberContainer>

				<Background2 $backgroundImage={background}>
					<div>
						<Tiki2 src={tiki} alt="Tiki" bottom="10px" />
					</div>
					<div>
						<Text
							color="#462C12"
							fontFamily="Inter"
							fontSize="16px"
							fontWeight={700}
							lineHeight="17px"
						>
							Your purchases earn
							<br /> Loyalty Points
						</Text>
						<Text
							color="#462C12"
							fontFamily="Inter"
							fontSize="12px"
							lineHeight="15px"
						>
							Use Loyalty Points to unlock special
							<br /> rewards in the Loyalty Shop.
						</Text>
					</div>
					<Button className="to-lp-shop" onClick={onNext}>
						View Loyalty Shop
					</Button>
					<Button className="skip" variant="text" onClick={onSkip}>
						Skip
					</Button>
				</Background2>
			</Container>
		</>
	);
};
